import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { AdminPanel } from "../../components/admin/AdminPanel";
import { Badge } from "../../components/ui/Badge";

export function AdminSettingsPage() {
  return (
    <div>
      <AdminPageHeader title="Settings" description="Early platform settings that anchor operational control without overbuilding configuration." />
      <div className="grid gap-6 lg:grid-cols-2">
        <AdminPanel title="Platform">
          <dl className="space-y-4 text-sm">
            <div><dt className="font-semibold text-ink">Platform name</dt><dd className="mt-1 text-graphite/70">CoachGrid</dd></div>
            <div><dt className="font-semibold text-ink">Support email</dt><dd className="mt-1 text-graphite/70">Not configured</dd></div>
            <div><dt className="font-semibold text-ink">Maintenance mode</dt><dd className="mt-1"><Badge tone="neutral">placeholder</Badge></dd></div>
          </dl>
        </AdminPanel>
        <AdminPanel title="Defaults">
          <dl className="space-y-4 text-sm">
            <div><dt className="font-semibold text-ink">Invite expiry</dt><dd className="mt-1 text-graphite/70">14 days</dd></div>
            <div><dt className="font-semibold text-ink">Tenant plan</dt><dd className="mt-1 text-graphite/70">starter</dd></div>
            <div><dt className="font-semibold text-ink">Feature flags</dt><dd className="mt-1 text-graphite/70">Seeded globally, tenant overrides supported</dd></div>
          </dl>
        </AdminPanel>
        <AdminPanel title="Support access">
          <p className="text-sm leading-6 text-graphite/70">
            View-as and impersonation are intentionally not implemented. Any future support access must be server-controlled, time-bounded and heavily audited.
          </p>
        </AdminPanel>
      </div>
    </div>
  );
}
